import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Tooltip,
  Chip,
  Switch,
  Alert,
  AlertTitle,
  Autocomplete,
  Snackbar,
  Backdrop,
  Container,
  Button,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  useMediaQuery,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WorkIcon from "@mui/icons-material/Work";
import { ControlledBoard } from "../Candidates/board";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DataTable from "../Candidates/DataTable";
import { COLORS } from "colors/color";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CandidateApplicationsList from "views/Candidates/CandidateApplicationsList";
import RecruiterCandidatesApplications from "views/Candidates/RecruiterCandidatesApplications ";
import RecruiterCandidatesApplicationsPDF from "views/Candidates/RecruiterCandidatesApplicationsPDF";
import AutoModeIcon from "@mui/icons-material/AutoMode";
import { CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PostButton } from "components/Buttons/Buttons";
import { Edit, ShareIcon } from "lucide-react";
import QRCodeDialog from "views/Posts/QRCodeDialog";
import { Google, Microsoft } from "@mui/icons-material";
import { NewPostButton } from "components/Buttons/Buttons";
import arrow_back_icon from "../../assets/img/arrow_back_icon.svg";
import { useTranslation } from "react-i18next";
import pencil_icon from "../../assets/img/pencil_icon.svg";
import OfferDetails from "views/Posts/Tabs/OfferDetails/OfferDetails";
import PublishedOffers from "views/Posts/PublishedOffers";
import useFetchRecruiter from "hooks/useFetchRecruiter";
import ScrapedCandidate from "./ScrapedCandidate";
import GmailAuth from "./GmailAuth";
import { Style, UploadFile } from "@mui/icons-material"
import ImportResumes from "views/Posts/imported/ImportResumes";
import { getApplicationStatusEmailTemplate } from "views/Candidates/email_templates";
import EditPostDetailsDialog from "views/Posts/Dialogs/EditPostDetailsDialog";
import EditWorkingDetailsDialog from "views/Posts/Dialogs/EditWorkingDetailsDialog";
import { useSnackbar } from "hooks/useSbackbar";
// import ImportResumes from "./imported/ImportResumes";
const StyledTypography = styled(Typography)(() => ({
  fontFamily: "Poppins",
}));
const ToggleButton = styled(Button)(({ theme, active }) => ({
  backgroundColor: active ? COLORS.signIn : COLORS.white,
  color: active ? COLORS.white : COLORS.signIn,
  border: `1px solid ${COLORS.signIn}`,
  "&:hover": {
    backgroundColor: active ? COLORS.signIn : COLORS.Button_OnHold,
    // opacity: 0.9,
  },
  padding: "8px 16px",
  fontWeight: "bold",
  textTransform: "none",
  transition: "all 0.3s ease",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: COLORS.Button_OnHold,
  color: COLORS.signIn,
  borderColor: COLORS.signIn,
  border: `1px solid ${COLORS.signIn}`,
  "&:hover": {
    backgroundColor: COLORS.signIn,
    color: "white",
  },
  padding: "10px 20px",
  marginLeft: "2%",
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: "bold",
  fontSize: "10px",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
  transition: "all 0.3s ease",
}));

const ProfileCard = styled(Card)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  borderRadius: "8px",
  overflow: "hidden",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
}));

const ProfileImageWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "220px", // Increased height to accommodate title
}));

const ProfileImage = styled(CardMedia)(({ theme }) => ({
  height: "100%",
  backgroundSize: "cover",
  backgroundPosition: "center",
  "&::after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      "linear-gradient(to bottom, rgba(0,0,0,0.0) 0%, rgba(0,0,0,0.7) 100%)",
  },
}));

const JobTitle = styled(Typography)(({ theme }) => ({
  position: "absolute",
  bottom: theme.spacing(2),
  left: theme.spacing(2),
  right: theme.spacing(2),
  color: "white",
  fontSize: "3.5rem",
  fontWeight: 700,
  textShadow: "0 2px 4px rgba(0,0,0,0.1)",
  zIndex: 1,
}));

const DeadlineChip = styled(Chip)(({ theme }) => ({
  color: "#000",
  position: "absolute",
  top: theme.spacing(2),
  right: theme.spacing(2),
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  // color: theme.palette.primary.main,
  fontWeight: 600,
  zIndex: 1,
}));

const CardContentWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "calc(100% - 220px)", // Subtract image wrapper height
  overflow: "hidden",
}));

const ScrollableContent = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  overflowY: "auto",
  padding: theme.spacing(3),
  "&::-webkit-scrollbar": {
    width: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#f1f1f1",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#c1c1c1",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "#a8a8a8",
    },
  },
}));
const RequirementChip = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(0.5),
  backgroundColor: COLORS.Button_OnHold,
}));

const PostDetailsScraped = () => {
  const { showSnackbar2 } = useSnackbar();
  const [applications, setApplications] = useState([]);
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState("candidates");
  const [steps, setSteps] = useState([]);
  const [stepId, setStepId] = useState();
  const userRole = getUserRoleFromAccessToken();
  const userId = getUserIdFromAccessToken();
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [code, setCode] = useState("");
  const [isScrappingLaunched, setIsScrappingLaunched] = useState(false);
  const [state, statechange] = useState(false);
  const [finishing, setfinishing] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showStopMessage, setShowStopMessage] = useState(false);
  const intervalIdRef = useRef(null);
  const apiUrlFront = process.env.REACT_APP_API_FRONT_URL;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // const { post } = location.state;
  const [post, setPost] = useState([]);
  const { id } = useParams();
  const decodedId = atob(id);
  const [isLoading, setIsLoading] = useState(false);
  const [showQRCodeDialog, setShowQRCodeDialog] = useState(false);
  const [urlCopied, setUrlCopied] = useState(false);
  const [qrCodeUrl, setQRCodeUrl] = useState("");
  const [isGmailAuthOpen, setIsGmailAuthOpen] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const [shouldRefreshApplications, setShouldRefreshApplications] = useState(false);
  const [applicationsImported, setApplicationsImported] = useState([]);
  const [filterOptions, setFilterOptions] = useState({ quiz: false });


  const [scrapingStatus, setScrapingStatus] = useState({
    status: null,
    message: "",
  });
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessingOutlook, setIsProcessingOutlook] = useState(false);
  const [showGmailAuth, setShowGmailAuth] = useState(false);
  const [fullStepData, setFullStepData] = useState([]);
  const { formData, loading, error } = useFetchRecruiter();

  const handleStartGmailScraping = () => {
    setIsProcessing(true);
    setShowGmailAuth(true);
  };

  const handleAuthComplete = (sessionId, result) => {
    console.log("Gmail processing completed:", result);
    setIsProcessing(false);
    setShowGmailAuth(false);
    Load_applications_imported();
    // Handle any post-processing here
  };

  // Close the Gmail auth dialog
  const handleCloseGmailAuth = () => {
    setIsGmailAuthOpen(false);
  };

  const { t } = useTranslation();
  const getPost = async () => {
    try {
      const response = await axios.get(`${apiUrl}posts/${decodedId}/find`);
      // console.log('voila voila: ',response.data.title)
      console.log("voila voila: ", response.data);
      setPost(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching job data:", error);
      setIsLoading(false);
      // Handle error (e.g., show error message to user)
    }
  };
  const getAccountTypeDisplay = (type) => {
    switch (type) {
      case "m":
        return {
          label: "Microsoft",
          icon: <Microsoft size={20} style={{ marginRight: 8 }} />,
        };
      case "g":
        return {
          label: "Google",
          icon: <Google size={20} style={{ marginRight: 8 }} />,
        };
      default:
        return { label: "Unknown", icon: null };
    }
  };
  const [accountType, setAccountType] = useState(getAccountTypeDisplay(post.accountType));

  useEffect(() => {
    getPost();
  }, []);
  useEffect(() => {
    console.log("here is decoded:", id);
  }, []);
  useEffect(() => {
    console.log("post id :", post.id);
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    if (code && window.opener) {
      window.opener.postMessage({ code: code }, window.location.origin);
      window.close();
    }
  }, []);


  function parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    console.log("payload : ", jsonPayload);

    return JSON.parse(jsonPayload);
  }

  function getUserIdFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return null;

    try {
      const base64Url = accessToken.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload).user_id;
    } catch (e) {
      console.error("Error decoding access token:", e);
      return null;
    }
  }

  function getUserRoleFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return null;

    try {
      const base64Url = accessToken.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload).role;
    } catch (e) {
      console.error("Error decoding access token:", e);
      return null;
    }
  }

  async function Load_applications_imported() {
    try {
      const response = await fetch(
        `${apiUrl}authentication/candidates-scraped-for-post/${post.id}/`,
        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );
      if (response.status === 401) {
        return;
      }
      const json = await response.json();
      setApplicationsImported(json);
      console.log("applications imported : ", json);
    } catch (error) {
      console.error("Error loading applications:", error);
    }
  }

  const Load_applications_with_filters = async () => {
    try {
      let quizParam = filterOptions.quiz ? "?quiz=true" : "";

      if (filterOptions.quiz_answers && Object.keys(filterOptions.quiz_answers).length > 0) {
        const prefix = quizParam ? "&" : "?";
        quizParam += `${prefix}quiz_answers=${encodeURIComponent(JSON.stringify(filterOptions.quiz_answers))}`;
      }

      if (filterOptions.step) {
        const prefix = quizParam ? "&" : "?";
        quizParam += `${prefix}step=${encodeURIComponent(filterOptions.step)}`;
      }

      const response = await fetch(
        `${apiUrl}authentication/candidates-scraped-for-post/${post.id}/${quizParam}`,
        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );
      if (response.status === 401) return;
      const json = await response.json();
      setApplicationsImported(json);
    } catch (error) {
      console.error("Error loading applications with filters:", error);
    }
  };

  useEffect(() => {
    if (post && post.id) {
      Load_applications_with_filters();
    }
  }, [post, filterOptions.quiz, JSON.stringify(filterOptions.quiz_answers || {}), filterOptions.step]);

  async function Load_applications() {
    try {
      const response = await fetch(
        `${apiUrl}authentication/candidates-scraped-for-post/${post.id}/`,
        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );
      if (response.status === 401) {
        return;
      }
      const json = await response.json();
      setApplications(json);
    } catch (error) {
      console.error("Error loading applications:", error);
    }
  }

  useEffect(() => {
    if (userRole !== "r") {
      console.log("User is not a recruiter. Navigating to home.");
      navigate("/landing");
    }
  }, [userRole, navigate]);

  useEffect(() => {
    Load_applications();
  }, [post]);
  useEffect(() => {
    const fetchSteps = async () => {
      console.log("UserId :", userId);
      try {
        const response = await fetch(
          `${apiUrl}recruiters/steps/?post=${post.id}`,
          {
            method: "GET",
            headers: {
              "Content-type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        if (Array.isArray(data)) {
          const stepTitles = data.map((step) => step.step);
          setSteps(stepTitles);

          const fullStepData = data.map((step) => ({
            id: step.id,
            title: step.step,
          }));
          setFullStepData(fullStepData);

          console.log("Step titles:", stepTitles);
          console.log("Full step data:", fullStepData);
        } else {
          console.error("Fetched data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching steps:", error);
      }
    };
    fetchSteps();
  }, [apiUrl, userId]);

  const deleteSteps = async (stepTitle) => {
    if (!stepTitle) return; // Don't do anything if stepTitle is null or undefined

    console.log("Deleting step:", stepTitle);

    const stepToDelete = fullStepData.find(
      (step) => step.title === stepTitle
    );
    if (stepToDelete) {
      try {
        const response = await fetch(
          `${apiUrl}recruiters/steps/${stepToDelete.id}/delete/?recruiter=${userId}`,
          {
            method: "DELETE",
            headers: {
              "Content-type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log("Step deleted:", data);

        // Update steps after deletion
        setSteps((prevSteps) =>
          prevSteps.filter((step) => step !== stepTitle)
        );

        // Update fullStepData after deletion
        setFullStepData((prevData) =>
          prevData.filter((step) => step.title !== stepTitle)
        );
      } catch (error) {
        console.error("Error deleting step:", error);
      }
    } else {
      console.error("Step not found for deletion:", stepTitle);
    }
  };

  // useEffect(() => {
  //   const fetchSteps = async () => {
  //     console.log("UserId :", userId);
  //     try {
  //       // Check if we've exceeded the timeout duration
  //       if (Date.now() - startTime > timeoutDuration) {
  //         console.log("Polling timeout reached (3 minutes). Stopping API calls.");
  //         clearInterval(intervalIdRef.current);
  //         intervalIdRef.current = null;
  //         setIsScrappingLaunched(false);
  //         statechange(false);
  //         setfinishing(true);
  //         setIsProcessingOutlook(false);
  //         setScrapingStatus({
  //           status: 'timeout',
  //           message: 'Operation timed out after 3 minutes'
  //         });
  //         return;
  //       }

  //       const response = await fetch(
  //         `${apiUrl}recruiters/steps/?recruiter=${userId}`,
  //         {
  //           method: "GET",
  //           headers: {
  //             "Content-type": "application/json",
  //             Authorization: "Bearer " + localStorage.getItem("accessToken"),
  //           },
  //         }
  //       );
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }
  //       const data = await response.json();

  //       if (Array.isArray(data)) {
  //         const stepTitles = data.map((step) => step.step);
  //         setSteps(stepTitles);

  //         const fullStepData = data.map((step) => ({
  //           id: step.id,
  //           title: step.step,
  //         }));
  //         setFullStepData(fullStepData);

  //         console.log("Step titles:", stepTitles);
  //         console.log("Full step data:", fullStepData);
  //       } else {
  //         console.error("Fetched data is not an array:", data);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching steps:", error);
  //     }
  //   };
  //   fetchSteps();
  // }, [apiUrl, userId]);


  useEffect(() => {
    console.log("post id :", post.id);
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    if (code && window.opener) {
      window.opener.postMessage({ code: code }, window.location.origin);
      window.close();
    }
  }, []);
  const createStep = (stepName) => {
    const addSteps = async () => {
      try {
        const response = await axios.post(
          `${apiUrl}recruiters/steps/create/`,
          {
            step: stepName,
            post: post.id,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );

        console.log("Step added successfully:", response.data);

        // Update steps and fullStepData only if the step was successfully added to the database
        if (response.data && response.data.id) {
          setSteps((prevSteps) => {
            // Check if the step already exists to prevent duplication
            if (!prevSteps.includes(stepName)) {
              return [...prevSteps, stepName];
            }
            return prevSteps;
          });

          setFullStepData((prevData) => {
            // Check if the step already exists to prevent duplication
            if (!prevData.some((step) => step.title === stepName)) {
              return [...prevData, { id: response.data.id, title: stepName }];
            }
            return prevData;
          });
        }
      } catch (error) {
        if (error.response) {
          console.error("Error adding step:", error.response.data);
        } else {
          console.error("Error adding step:", error.message);
        }
      }
    };
    addSteps();
  };


  const handleSendEmail = async (emailData) => {
    try {
      // Destructure email data
      const { userId: userId, to: receiver, subject, body } = emailData;

      // Prepare payload for backend
      const payload = {
        user_id: userId,
        to: receiver,
        subject,
        body,
      };
      console.log("here is the send data", payload);

      // Send email using backend API
      const response = await axios.post(
        `${apiUrl}authentication/api/send-email/`,
        payload
      );

      // Handle successful email sending
      console.log("Email sent successfully!");
      return response.data;
    } catch (error) {
      // Handle any errors in email sending
      // console.error("Email sending failed:", error);
      // alert(error.response?.data?.detail || "Failed to send email");
      showSnackbar2(
        `Submission error: ${JSON.stringify(error.response.data)}`,
        {
          severity: "error",
          position: "bottom-left",
          duration: 5000,
        }
      );
      throw error;
    }
  };
  const updateApplicationStep = async (applicationId, newStep, status, description) => {


    try {
      const url = status !== "Application-Imported" && status !== "Scraping-Email"
        ? `${apiUrl}authentication/applications/${applicationId}/update-step/`
        : `${apiUrl}authentication/applicationsscraped/${applicationId}/update-step/`;

      console.log("updatedApplications : ", applicationId, newStep, " status : ", status, " Link : ", url);
      const response = await axios.patch(
        url,
        { step: newStep },
        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.status === 200) {
        // Send email notification about step update
        const emailBody = getApplicationStatusEmailTemplate({
          status: newStep,
          jobTitle: post.title || "the position", // Add job title if available
          companyName: "Your Company Name", // Replace with your company name
          jobUrl: `${apiUrlFront}viewjob/${btoa(post)}`,
          date: new Date().toLocaleString(),
          additionalMessage: null // Add any additional message if needed
        });
        const emailData = {
          userId: userId,
          to: description, // Assuming post has an email field for notifications
          subject: `Application Status Update - ${newStep}`,
          body: emailBody,
        };
        await handleSendEmail(emailData);

        const updatedApplications = applications.map((app) =>
          app.id === applicationId ? { ...app, step: newStep } : app
        );
        setApplicationsImported(updatedApplications);
        console.log("updatedApplications : ", updatedApplications);
      }
    } catch (error) {
      console.error("Error updating application step:", error);
    }
  };

  const Scrapping = async () => {
    try {
      // Start the scraping process
      setIsProcessingOutlook(true);
      console.log("here is the post id: ", post.id);
      const response = await fetch(
        `${apiUrl}ai/start_scraping_post/${post.id}/?source_call=post&sujet=${encodeURIComponent('subject')}`,
        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },

        }
      );

      if (response.status === 401) {
        console.log("Unauthorized. Redirecting to login page...");
        navigate("/login");
        return;
      }

      const result = await response.json();
      console.log("Scraping task initiated: ", result);

      // Handle the new state format while maintaining backward compatibility
      if (result.state === "in_progress" || result.state === true) {
        // Clear any existing interval before starting a new one
        if (intervalIdRef.current) {
          clearInterval(intervalIdRef.current);
          intervalIdRef.current = null;
        }
        pollScrapingStatus(post.id);
      } else {
        console.error("Failed to start scraping: ", result.message);
      }
    } catch (error) {
      console.error("Error initiating scraping:", error);
    }
  };

  const pollScrapingStatus = async (id) => {
    try {
      console.log("before the 30s");
      await new Promise((resolve) => setTimeout(resolve, 30000));
      console.log("after the 30s");

      // Add a variable to track the start time
      const startTime = Date.now();
      const timeoutDuration = 3 * 60 * 1000; // 3 minutes in milliseconds

      intervalIdRef.current = setInterval(async () => {
        try {
          // Check if we've exceeded the timeout duration
          if (Date.now() - startTime > timeoutDuration) {
            console.log(
              "Polling timeout reached (3 minutes). Stopping API calls."
            );
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
            setIsScrappingLaunched(false);
            statechange(false);
            setfinishing(true);
            setIsProcessingOutlook(false);
            setScrapingStatus({
              status: "timeout",
              message: "Operation timed out after 3 minutes",
            });
            return;
          }

          const response = await fetch(
            `${apiUrl}ai/get_scraping_status/${post.id}/`,
            {
              headers: {
                "Content-type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("accessToken"),
              },
            }
          );

          const result = await response.json();
          console.log("Polling result: ", result);

          // Update the scraping status based on the response
          setScrapingStatus({
            status: result.state,
            message: result.message,
          });

          if (result.state !== "in_progress" && result.state !== "pending") {
            if (intervalIdRef.current) {
              clearInterval(intervalIdRef.current);
              intervalIdRef.current = null;
            }

            setIsScrappingLaunched(false);
            statechange(false);
            setfinishing(true);

            if (result.state === "success" || result.state === true) {
              setOpenSnackbar(true);
              setIsProcessingOutlook(false);
              Load_applications_imported();
            }
          }
        } catch (error) {
          console.error("Error in polling interval:", error);
          setScrapingStatus({
            status: "failed",
            message: "Error occurred while scraping",
          });
          if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
          }
        }
      }, 5000);
    } catch (error) {
      console.error("Error polling scraping status:", error);
    }
  };
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editWorkingDialogOpen, setEditWorkingDialogOpen] = useState(false);
  const [postTitle, setPostTitle] = useState("");
  const [postDescription, setPostDescription] = useState("");
  const [postRequirement, setPostRequirement] = useState([]);
  const [postDeadline, setPostDeadline] = useState("");
  const [offerType, setOfferType] = useState("job");
  const [errors, setErrors] = useState({});
  const [dateError, setDateError] = useState("");
  const [reference, setReference] = useState("");
  // const [accountType, setAccountType] = useState("");
  const [recruiterEmail, setRecruiterEmail] = useState("");
  // Working details states
  const [workingMode, setWorkingMode] = useState("Remote");
  const [location, setLocation] = useState("");
  const [numPeople, setNumPeople] = useState("");
  const [salary, setSalary] = useState("");
  const [currency, setCurrency] = useState("MAD");
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedScr, setIsCheckedScr] = useState(false);
  const [experience, setExperience] = useState("");
  const [diploma, setDiploma] = useState("");
  const [otherDiploma, setOtherDiploma] = useState("");
  const [fieldOfStudy, setFieldOfStudy] = useState("");
  const [otherFieldOfStudy, setOtherFieldOfStudy] = useState("");
  const [postImage, setPostImage] = useState("");
  const handleEditClick = () => {
    setEditDialogOpen(true);
  };
  const handleDateChange = (newDate) => {
    setPostDeadline(newDate);
    setDateError("");
  };

  const handleNext = () => {
    // Validate form
    const newErrors = {};

    if (!postTitle.trim()) {
      newErrors.postTitle = t("errors.requiredField");
    }

    if (!postDescription.trim()) {
      newErrors.postDescription = t("errors.requiredField");
    }

    if (!offerType) {
      newErrors.offerType = t("errors.requiredField");
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Move to second dialog
    setEditDialogOpen(false);
    setEditWorkingDialogOpen(true);
  };
  const handleSave = async (secondDialogData) => {
    try {
      // Format the data to match API expectations
      const completeUpdateData = {
        postId: post.id,
        title: postTitle,
        description: postDescription,
        requirements: postRequirement,
        deadline: postDeadline,
        reference: reference || null,
        mode: secondDialogData.mode,
        localisation: secondDialogData.localisation,
        age_experience: secondDialogData.age_experience || null,
        salary: secondDialogData.salary !== "" ? secondDialogData.salary : null,
        offerType: offerType === "internship" ? "i" : "j",
        image: secondDialogData.image,
        field_of_study: secondDialogData.field_of_study,
        highest_diploma: secondDialogData.highest_diploma,
        currency: secondDialogData.currency || currency
      };

      console.log("Sending update with data:", completeUpdateData);

      // Call API to update post
      console.log("it's been called here 1!!")
      const response = await axios.put(`${apiUrl}posts/${post.id}/update/`, completeUpdateData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      });

      if (response.status === 200) {
        // Update local post state
        setPost(prev => ({
          ...prev,
          ...completeUpdateData,
          offerType: offerType === "internship" ? "i" : "j"
        }));

        // Close dialog
        setEditWorkingDialogOpen(false);

        // Show success message
        console.log("Post updated successfully");
      }
    } catch (error) {
      console.error("Error updating post:", error);
    }
  };

  const handleImageUpload = (image) => {
    setPostImage(image);
    setErrors((prev) => ({ ...prev, postImage: "" }));
  };

  const handleSalaryChange = (value) => {
    setSalary(value);
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleCheckboxChangeScr = (event) => {
    setIsCheckedScr(event.target.checked);
  };

  useEffect(() => {
    if (post && post.id) {
      setPostTitle(post.title || "");
      setPostDescription(post.description || "");
      setPostRequirement(post.requirements || []);
      setPostDeadline(post.deadline || "");
      setOfferType(post.offerType === "i" ? "internship" : "job");
      setReference(post.reference || "");
      setAccountType(post.accountType || "");
      setRecruiterEmail(post.recruiter_email || "");
      setWorkingMode(post.mode || "Remote");
      setLocation(post.localisation || "");
      setNumPeople(post.age_experience || "");
      setSalary(post.salary || "");
      setCurrency(post.currency || "MAD");
      setExperience(post.experiences || "");
      setDiploma(post.highest_diploma || "");
      setFieldOfStudy(post.field_of_study || "");
      setPostImage(post.image || "");
    }
  }, [post]);

  // Clean up the interval when the component unmounts
  React.useEffect(() => {
    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
    };
  }, []);

  const code_outlook = async () => {
    try {
      const response = await fetch(`${apiUrl}ai/code_outlook/${post.id}/`);
      const result = await response.json();
      console.log("code : ", result.user_code);
      setCode(result.user_code);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  function openAuthPopup() {
    const authUrl =
      "https://login.microsoftonline.com/common/oauth2/deviceauth";
    const width = window.screen.width / 3;
    const height = window.screen.height;
    const left = window.screen.width - width;
    const top = 0;

    window.open(
      authUrl,
      "authPopup",
      `width=${width},height=${height},top=${top},left=${left}`
    );
  }
  const hidde_finishing = () => {
    // Clear the interval if it exists
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
    }
    setfinishing(false);
    statechange(false);
    setIsScrappingLaunched(false);
    setShowStopMessage(true);
  };
  const handleCloseStopMessage = () => {
    setShowStopMessage(false);
  };
  const handleCopy = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(code)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
        })
        .catch(() => {
          setSnackbarOpen(true);
        });
    } else {
      setSnackbarOpen(true);
    }
  };
  const ScrappingGmail = async () => {
    try {
      // Start the scraping process
      console.log("here is the post id: ", post.id);
      const response = await fetch(
        `${apiUrl}ai/start_scraping_post_gmail/${post.id}/`,
        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.status === 401) {
        console.log("Unauthorized. Redirecting to login page...");
        navigate("/login");
        return;
      }

      const result = await response.json();
      console.log("Scraping task initiated: ", result);

      // Handle the new state format while maintaining backward compatibility
      if (result.state === "in_progress" || result.state === true) {
        // Clear any existing interval before starting a new one
        if (intervalIdRef.current) {
          clearInterval(intervalIdRef.current);
          intervalIdRef.current = null;
        }
        pollScrapingStatus(post.id);
      } else {
        console.error("Failed to start scraping: ", result.message);
      }
    } catch (error) {
      console.error("Error initiating scraping:", error);
    }
  };
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const visualizePost = () => {
    console.log("visualizePost clicked!!");
    const encodedId = btoa(post.id); // Encode the ID
    navigate(`/viewjob/${encodedId}`);
  };
  const copyViewJobUrl = () => {
    const encodedId = btoa(post.id); // Encode the ID
    const url = `${window.location.origin}/viewjob/${encodedId}`;

    // Copy to clipboard
    navigator.clipboard.writeText(url).then(() => {
      // Set the URL for QR code and open dialog
      setQRCodeUrl(url);
      setShowQRCodeDialog(true);
    });
  };
  const [importDialogOpen, setImportDialogOpen] = useState(false);

  const handleOpenImportDialog = () => {
    setImportDialogOpen(true);
  };

  const handleCloseImportDialog = () => {
    setImportDialogOpen(false);
  };
  const handleCloseQRCodeDialog = () => {
    setShowQRCodeDialog(false);
  };
  const handleImportSuccess = () => {
    setShouldRefreshApplications(true);
  };
  useEffect(() => {
    Load_applications_imported();

    // Reset the flag after loading
    if (shouldRefreshApplications) {
      setShouldRefreshApplications(false);
    }
  }, [shouldRefreshApplications]);

  useEffect(() => {
    Load_applications_imported();
  }, [post]);

  const [tableType, setTableType] = useState("Offer_details");

  const handleTableTypeChange = (event, newValue) => {
    setTableType(newValue);
    setTabPage(0);
  };
  useEffect(() => {
    if (tableType === "Candidates" || tableType === "Steps_board") {
      Load_applications();
      Load_applications_imported();
    }
  }, [tableType]);



  const [tabPage, setTabPage] = useState(0);
  const renderTable = () => {
    switch (tableType) {
      case "Offer_details":
        return <OfferDetails post={post} scraping="1" />;
      case "Candidates":
        return (

          <DataTable
            candidates={applicationsImported}
            knob={true}
            steps={steps}
            post_id={post.id}
            onCandidatesUpdate={Load_applications_with_filters}
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
            onFilterApply={() => {
              Load_applications_with_filters();
            }}
            postQuiz={post?.quiz}
          />
        );
      case "Steps_board":
        return (
          <ControlledBoard
            candidates={applicationsImported}
            onUpdateStep={updateApplicationStep}
            deleteSteps={deleteSteps}
            setSteps={setSteps}
            setStepId={setStepId}
            createStep={createStep}
            steps={steps}
            post={post}
          />
        );

      default:
        return <OfferDetails />;
    }
  };

  const handleClose = () => {
    if (post.archived) {
      navigate("/talent/post/PostDetails", { state: { archived: true } });
    } else {
      navigate("/talent/post/PostDetails", { state: { archived: false } });
    }
  };

  return (
    <Container maxWidth="xl">
      <Box mt={3} mb={3} sx={{ display: "flex", gap: 2 }}>
        <NewPostButton
          sx={{
            gap: 1,
            "&:hover img": {
              filter: "brightness(0) invert(1)",
              transition: "filter 0.3s ease",
            },
          }}
          onClick={handleClose}
        >
          {" "}
          <img
            src={arrow_back_icon}
            style={{
              transition: "all 0.3s ease",
            }}
          />
          <Typography
            sx={{
              fontFamily: "Poppins",
              fontWeight: 400,
              fontSize: "14px",
            }}
          >
            {t("back_to_posts")}
          </Typography>
        </NewPostButton>
        <Grid item xs={3} sm="auto">
          <NewPostButton
            sx={{
              gap: 1,
              width: "100%",
              justifyContent: { xs: "center", sm: "flex-start" },
              "&:hover .MuiSvgIcon-root": {
                color: "white",
                transition: "color 0.3s ease",
              },
            }}
            onClick={visualizePost}
          >
            {isSmallScreen ? (
              <VisibilityIcon />
            ) : (
              <>
                <VisibilityIcon />
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontWeight: 400,
                    fontSize: "14px",
                  }}
                >
                  {t("visualize_post")}
                </Typography>
              </>
            )}
          </NewPostButton>
        </Grid>
        <Grid item xs={3} sm="auto">
          <NewPostButton
            sx={{
              gap: 1,
              width: "100%",
              justifyContent: { xs: "center", sm: "flex-start" },
              "&:hover .MuiSvgIcon-root": {
                color: "white",
                transition: "color 0.3s ease",
              },
            }}
            onClick={handleEditClick}
          >
            {isSmallScreen ? (
              <img
                src={pencil_icon}
                style={{
                  width: isMobile ? 14 : 14,
                  height: isMobile ? 14 : 14,
                  // background: red,
                }}
              />
            ) : (
              <>

                {/* If it's a custom SVG or other library: */}
                <Edit width="16" height="16" />
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontWeight: 400,
                    fontSize: "14px",
                  }}
                >
                  Modifier L'offre
                </Typography>
              </>
            )}
          </NewPostButton>
        </Grid>
        <NewPostButton
          sx={{
            gap: 1,
            "& .MuiButton-startIcon": {
              width: 16,
            },
            "&:hover .MuiSvgIcon-root": {
              color: "white",
              transition: "color 0.3s ease",
            },
          }}
          onClick={copyViewJobUrl}
          startIcon={<ShareIcon />}
        >
          <Typography
            sx={{
              fontFamily: "Poppins",
              fontWeight: 400,
              fontSize: "14px",
            }}
          >
            {t("share")}
          </Typography>
        </NewPostButton>
        {/* Import Resumes Button */}
        <Grid item xs={3} sm="auto">
          <NewPostButton
            sx={{
              gap: 1,
              width: "100%",
              justifyContent: { xs: "center", sm: "flex-start" },
              "&:hover .MuiSvgIcon-root": {
                color: "white",
                transition: "color 0.3s ease",
              },
            }}
            onClick={handleOpenImportDialog}
          >
            {isSmallScreen ? (
              <UploadFile />
            ) : (
              <>
                <UploadFile />
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontWeight: 400,
                    fontSize: "14px",
                  }}
                >
                  {t('postDetails.importResumes')}
                </Typography>
              </>
            )}
          </NewPostButton>
        </Grid>
        <ImportResumes
          open={importDialogOpen}
          onClose={handleCloseImportDialog}
          postID={post.id}
          onImportSuccess={handleImportSuccess}
        />
        {post.accountType === "m" ? (
          <NewPostButton
            sx={{
              gap: 1,
              width: "15%",
              justifyContent: { xs: "center", sm: "flex-start" },
              "&:hover .MuiSvgIcon-root": {
                color: "white",
                transition: "color 0.3s ease",
              },
            }}
            onClick={() => {
              statechange(true);
              Scrapping();
            }}
            disabled={isProcessingOutlook}
            onMouseUp={() => {
              setTimeout(() => {
                code_outlook();
                setIsScrappingLaunched(true);
              }, 2000);
              setTimeout(() => {
                openAuthPopup();
              }, 5000);
            }}
            startIcon={<AutoModeIcon />}
          >
            {isProcessingOutlook ? "Processing Outlook..." : "Outlook Scraping"}
          </NewPostButton>
        ) : (
          <NewPostButton
            sx={{
              gap: 1,
              width: "15%",
              justifyContent: { xs: "center", sm: "flex-start" },
              "&:hover .MuiSvgIcon-root": {
                color: "white",
                transition: "color 0.3s ease",
              },
            }}
            startIcon={<AutoModeIcon />}
            onClick={handleStartGmailScraping}
            disabled={isProcessing}
          >
            {isProcessing ? "Processing Gmail..." : "Gmail Scraping"}
          </NewPostButton>
        )}
        {showGmailAuth && (
          <GmailAuth
            onAuthComplete={handleAuthComplete}
            postId={post.id} // Pass the current post ID
            sourceCall='post'
            sujet=''
          />
        )}
        {isScrappingLaunched ? (
          <>
            <StyledButton>{code}</StyledButton>
            <Tooltip title={copied ? "Copied!" : "Copy code"}>
              <IconButton onClick={handleCopy} size="small" sx={{ ml: 2 }}>
                {copied ? (
                  <CheckCircleIcon color="success" />
                ) : (
                  <ContentCopyIcon />
                )}
              </IconButton>
            </Tooltip>{" "}
          </>
        ) : (
          <></>
        )}
      </Box>
      <QRCodeDialog
        open={showQRCodeDialog}
        onClose={handleCloseQRCodeDialog}
        qrCodeUrl={qrCodeUrl}
        formData={post}
      />

      <div className="col-md-4 text-right mr-2">
        {/* Top-right corner loading element */}
        <div
          style={{
            position: "fixed",
            top: 20,
            right: 20,
            zIndex: 9999,
            display:
              scrapingStatus.status === "in_progress" || showLoading
                ? "flex"
                : "none",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            padding: "10px 20px",
            borderRadius: "8px",
            gap: "10px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
          }}
        >
          <CircularProgress size={24} thickness={4} sx={{ color: "#4CAF50" }} />
          <span style={{ fontSize: "1rem", color: "#fff" }}>
            {scrapingStatus.message || "Scraping in progress..."}
          </span>
          <IconButton
            size="small"
            onClick={hidde_finishing}
            sx={{ color: "white", marginLeft: "5px" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        {/* Stopped Scraping Alert */}
        <Snackbar
          open={showStopMessage}
          onClose={handleCloseStopMessage}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseStopMessage}
            severity="warning"
            sx={{
              width: "100%",
              "& .MuiAlert-message": {
                fontSize: "1rem",
              },
            }}
          >
            <AlertTitle>Scraping Stopped</AlertTitle>
            The scraping process has been stopped.
          </Alert>
        </Snackbar>

        {/* Success Toast */}
        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity="success"
            sx={{
              width: "100%",
              "& .MuiAlert-message": {
                fontSize: "1rem",
              },
            }}
          >
            <AlertTitle>Success</AlertTitle>
            {scrapingStatus.message || "Scraping completed successfully!"}
          </Alert>
        </Snackbar>

        {/* Failed Toast */}
        <Snackbar
          open={scrapingStatus.status === "failed"}
          autoHideDuration={2000}
          onClose={() => setScrapingStatus({ status: null, message: "" })}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={() => setScrapingStatus({ status: null, message: "" })}
            severity="error"
            sx={{
              width: "100%",
              "& .MuiAlert-message": {
                fontSize: "1rem",
              },
            }}
          >
            <AlertTitle>Error</AlertTitle>
            {scrapingStatus.message || "Scraping process failed"}
          </Alert>
        </Snackbar>
      </div>

      <Box sx={{ position: "relative", marginLeft: 5, marginBottom: 4 }}>
        {/* Static gray line */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "2.5px",
            backgroundColor: "divider",
            zIndex: 0,
          }}
        />

        <Tabs
          value={tableType}
          onChange={handleTableTypeChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            "& .MuiTabs-indicator": {
              height: "2px",
              zIndex: 1,
            },
            "& .MuiTab-root": {
              fontFamily: "Poppins",
              fontWeight: 500,
              fontSize: "14px",
            },
          }}
        >
          <Tab
            label={t("Offer details")}
            sx={{ fontFamily: "Poppins", textTransform: "none" }}
            value="Offer_details"
          />
          <Tab
            label={t("Candidates")}
            sx={{ fontFamily: "Poppins", textTransform: "none" }}
            value="Candidates"
          />
          <Tab
            label={t('postDetails.stepsBoard')}
            sx={{ fontFamily: "Poppins", textTransform: "none" }}
            value="Steps_board"
          />
        </Tabs>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{renderTable()}</>
      )}
      {/* Edit Dialogs */}
      <EditPostDetailsDialog
        setOpen={setEditDialogOpen}
        postTitle={postTitle}
        setPostTitle={setPostTitle}
        postDescription={postDescription}
        setPostDescription={setPostDescription}
        offerType={offerType}
        setOfferType={setOfferType}
        postRequirement={postRequirement}
        setPostRequirement={setPostRequirement}
        postDeadline={postDeadline}
        handleDateChange={handleDateChange}
        handleNext={handleNext}
        open={editDialogOpen}
        errors={errors}
        dateError={dateError}
        setDateError={setDateError}
        showRef={post.scraped}
        accountType={accountType}
        setAccountType={setAccountType}
        reference={reference}
        setReference={setReference}
        recruiterEmail={recruiterEmail}
        setRecruiterEmail={setRecruiterEmail}
        setErrors={setErrors}
      />

      <EditWorkingDetailsDialog
        setOpen2={setEditWorkingDialogOpen}
        setOpen={setEditDialogOpen}
        open2={editWorkingDialogOpen}
        errors={errors}
        handleImageUpload={handleImageUpload}
        setWorkingMode={setWorkingMode}
        workingMode={workingMode}
        location={location}
        setLocation={setLocation}
        setErrors={setErrors}
        numPeople={numPeople}
        setNumPeople={setNumPeople}
        salary={salary}
        handleSalaryChange={handleSalaryChange}
        currency={currency}
        setCurrency={setCurrency}
        isChecked={isChecked}
        handleCheckboxChange={handleCheckboxChange}
        isCheckedScr={isCheckedScr}
        handleCheckboxChangeScr={handleCheckboxChangeScr}
        handleSave={handleSave}
        experience={experience}
        setExperience={setExperience}
        diploma={diploma}
        setDiploma={setDiploma}
        otherDiploma={otherDiploma}
        setOtherDiploma={setOtherDiploma}
        fieldOfStudy={fieldOfStudy}
        setFieldOfStudy={setFieldOfStudy}
        otherFieldOfStudy={otherFieldOfStudy}
        setOtherFieldOfStudy={setOtherFieldOfStudy}
        job={post}
        postTitle={postTitle}
      />
    </Container>
  );
};

export default PostDetailsScraped;
